import { render, staticRenderFns } from "./decoration12.vue?vue&type=template&id=38cfda52&scoped=true"
import script from "./decoration12.vue?vue&type=script&lang=js"
export * from "./decoration12.vue?vue&type=script&lang=js"
import style0 from "./decoration12.vue?vue&type=style&index=0&id=38cfda52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cfda52",
  null
  
)

export default component.exports